import React from 'react';
import styled, { css } from 'styled-components';

interface Props {
  active: boolean;
  onClick: (e?: React.MouseEvent) => any;
}

export function Toggle({ active, onClick, ...props }: Props) {
  return (
    <Container active={active} onClick={onClick} {...props}>
      <Knob active={active} />
    </Container>
  );
}

const Container = styled.div<{ active: boolean }>`
  width: 52px;
  height: 30px;
  border-radius: 999px;
  padding: 1.5px ${({ active }) => (active ? '0px' : '2.5px')};
  background-color: ${({ active, theme }) => (active ? theme.white : 'unset')};
  border: 1px solid ${({ active, theme }) => (active ? theme.white : theme.medGray)};
  box-sizing: border-box;
  cursor: pointer;
  letter-spacing: 0.2px;
  transition: all 0.2s ease-out;
`;

const Knob = styled.div<{ active: boolean }>`
  width: 24px;
  height: 24px;
  box-shadow:
    0 3px 1px 0 rgba(0, 0, 0, 0.06),
    0 3px 8px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  border-radius: 13.5px;
  position: relative;
  transition: all 0.2s ease-out;

  ${({ active }) =>
    active &&
    css`
      margin-left: calc(100% - 27px);
      background-color: ${({ theme }) => theme.bbBlack};
    `}
`;
